import firebase from 'firebase/app';
import { Debug } from '../../common/utils/debugLogs';

export enum SNSType {
  GOOGLE,
  TWITTER,
  FACEBOOK,
  LINE,
  APPLE,
}

/**
 * Get token from firebase
 * @returns token
 */
export const getToken = async (): Promise<string | undefined> => {
  const currentUser = firebase.auth().currentUser;
  if (!currentUser) {
    return undefined;
  }

  const token = await currentUser?.getIdToken();
  return token;
};

/**
 * Sign out by firebase.
 */
export const signOut = async (): Promise<void> => {
  try {
    await firebase.auth().signOut();
    window.localStorage.clear();
  } catch (error) {
    Debug.error('Sign out error');
  }
};

/**
 * Sign in with SNS account.
 * @param type SNS type
 */
export const signInWithSNS = async (
  type: SNSType,
): Promise<firebase.User | null> => {
  await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);

  let provider;

  // choose auth ways: Google, Twitter, ...
  switch (type) {
    case SNSType.GOOGLE: {
      provider = new firebase.auth.GoogleAuthProvider();
      break;
    }
    case SNSType.TWITTER: {
      provider = new firebase.auth.TwitterAuthProvider();
      break;
    }
    case SNSType.FACEBOOK: {
      provider = new firebase.auth.FacebookAuthProvider();
      break;
    }
    case SNSType.APPLE: {
      provider = new firebase.auth.OAuthProvider('apple.com');
      break;
    }
    default:
      provider = new firebase.auth.EmailAuthProvider();
  }

  try {
    // sign in with pop up
    await firebase.auth().signInWithPopup(provider);
    return firebase.auth().currentUser;
  } catch (error) {
    Debug.error(`${type}: Sign in Error`);
    return null;
  }
};
